// File: src/components/Sidebar.tsx
import React from 'react'
import { Link } from 'react-router-dom'
import { LayoutDashboard, Users } from 'lucide-react'

const Sidebar = () => {
  return (
    <nav style={styles.sidebar}>
      <div style={styles.header}>
        <h1 style={styles.title}>Tribe Ads</h1>
      </div>
      <ul style={styles.menu}>
        <li style={styles.menuItem}>
          <Link to="/" style={styles.menuLink}>
            <LayoutDashboard style={styles.menuIcon} />
            <span>Campaign Units</span>
          </Link>
        </li>
        <li style={styles.menuItem}>
          <Link to="/advertisers" style={styles.menuLink}>
            <Users style={styles.menuIcon} />
            <span>Advertisers</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}

const styles = {
  sidebar: {
    width: '250px',
    backgroundColor: '#ffffff',
    boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
  },
  header: {
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #e0e0e0',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#3b82f6',
  },
  menu: {
    listStyleType: 'none',
    padding: '0',
    margin: '0',
  },
  menuItem: {
    padding: '0.5rem 1rem',
  },
  menuLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#4b5563',
    textDecoration: 'none',
    padding: '0.5rem',
    borderRadius: '4px',
  },
  menuIcon: {
    marginRight: '0.75rem',
  },
}
export default Sidebar
